// @flow

import * as React from "react";
import classNames from "classnames";
import "./landing-card-container.style.scss";

type Props = $Exact<{
  children?: React.Node,
  className?: string,
}>;

const LandingCardContainer = (
  props: Props, // TODO: so, this is separate component :D remove this noncense
) => <div className={classNames("landing-page-container", props.className)}>{props.children}</div>;

export default LandingCardContainer;
